var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationIconNew = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.99992C2.5 3.66659 5.16667 1.33325 8.5 1.33325C11.8333 1.33325 14.5 3.66659 14.5 6.99992C14.5 12.2345 9.83333 14.6665 8.5 14.6665C7.16667 14.6665 2.5 12.2345 2.5 6.99992Z",
    stroke: "#8C8F9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.33325C10.5 8.43782 9.60457 9.33325 8.5 9.33325C7.39543 9.33325 6.5 8.43782 6.5 7.33325C6.5 6.22868 7.39543 5.33325 8.5 5.33325C9.60457 5.33325 10.5 6.22868 10.5 7.33325Z",
    stroke: "#8C8F9D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationIconNew);
export default ForwardRef;